import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthContext } from "./AuthContext";
import { canAccessAdminRoutes, normalizeRole } from "./roles";

function AuthLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}

/** Require any authenticated Worker JWT session. */
export function RequireAuth({ children }) {
  const { user, loading } = useAuthContext();
  const location = useLocation();
  if (loading) return <AuthLoading />;
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}

/** Require admin or staff (legacy teacher/editor map to admin/staff). */
export function RequireAdmin({ children }) {
  const { user, loading } = useAuthContext();
  const location = useLocation();
  if (loading) return <AuthLoading />;
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (!canAccessAdminRoutes(user.role)) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

/** Require one of the listed normalized roles. */
export function RequireRole({ roles, children }) {
  const { user, loading } = useAuthContext();
  const location = useLocation();
  if (loading) return <AuthLoading />;
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  const normalized = normalizeRole(user.role);
  const allowed = roles.map((r) => normalizeRole(r));
  if (!allowed.includes(normalized)) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
